// extracted by mini-css-extract-plugin
export default {"container":"PushNotification_container__gZuSK","action":"PushNotification_action__U8LAh","actionText":"PushNotification_actionText__Q5gha"};